export const providerInterests = [
  {
    id: 1,
    name: 'Wellness',
    description: null,
    createdAt: '2021-06-16T10:36:26.462Z',
    updatedAt: '2021-06-16T10:36:26.462Z',
    createdBy: 1,
    updatedBy: 1,
  },
  {
    id: 2,
    name: 'Diabetes',
    description: null,
    createdAt: '2019-09-09T20:47:39.449Z',
    updatedAt: '2019-09-09T20:47:39.449Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Heart Disease',
    description: null,
    createdAt: '2019-09-09T20:47:39.449Z',
    updatedAt: '2019-09-09T20:47:39.449Z',
    createdBy: null,
    updatedBy: null,
  },
];
